export function checkIfDuplicateExists(arr) {
  return new Set(arr).size !== arr.length
}

export function getFormReducer(initialState, initialWarningState) {
  return function formReducer(state, action) {
    switch (action.type) {
      case "field": {
        return {
          ...state,
          [action.field]: action.value,
        }
      }
      case "clear": {
        return {
          ...state,
          ...initialState,
          ...initialWarningState,
        }
      }
      case "submit": {
        return {
          ...state,
          ...initialWarningState,
          isLoading: true,
        }
      }
      case "invalid-form": {
        return {
          ...state,
          isLoading: false,
        }
      }
    }
  }
}

export const displayRef = (containerID, show = true, display_style = "table") => {
  const container = document.getElementById(containerID)
  if (container) {
    container.style.display = show ? display_style : "none"
  }
}
